/*eslint-disable */

import HTTP from './HTTP';

export async function status() {
    return await HTTP.get('status');
};
